import { lazy, Suspense } from 'react';
import Layout from '../../layout/Layout';
import { SEO } from '../../components/SEO';
import './styles.scss';

const TuksumsMap = lazy(() =>
  import('components/molecules/TuksumsMap').then(m => ({ default: m.TuksumsMap }))
);

export const Home = ({ ...rest }) => (
  <Layout isHomePage>
    <SEO
      title="Interactive Map of Empty Storefronts in Riga"
      description="Explore Tuksums: an interactive map of empty storefronts and forgotten corners of Riga. Discover miniature memories left on the city map, where emptiness becomes a space for perception and interpretation."
      url="https://tuksums.lv"
      jsonLd={{
        '@context': 'https://schema.org',
        '@type': 'WebApplication',
        name: 'Tuksums',
        url: 'https://tuksums.lv',
        description: 'An interactive map of empty storefronts and forgotten corners of Riga, Latvia.',
        applicationCategory: 'EntertainmentApplication',
        operatingSystem: 'Web Browser',
        inLanguage: 'en',
        offers: { '@type': 'Offer', price: '0', priceCurrency: 'EUR' },
        author: { '@type': 'Organization', name: 'Tuksums', url: 'https://tuksums.lv' },
      }}
    />
    <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <Suspense fallback={
        <div style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#000'
        }}>
          <div style={{ color: '#f7df1c', fontSize: '18px' }}>Loading map...</div>
        </div>
      }>
        <TuksumsMap />
      </Suspense>
    </div>
  </Layout>
);
